<template>
  <div class="h-100">
    <div
      v-if="isShowChat && !(isNoConversation && currentSelectChatId == '')"
      class="d-flex h-100"
    >
      <div v-show="isList || isShowBoth" :class="['panel-list-chat']">
        <div v-if="isNoConversation" class="h-100 border-right">
          <div class="panel-wellcome-chat">
            <div class="text-center">
              <p class="mb-0">{{ $t("chatNotFound") }}</p>
            </div>
          </div>
        </div>
        <ChatList
          v-else
          ref="ChatList"
          @select-chat="handleSelectChat"
          :meProfile="meProfile"
          @set-show-title="(val) => $emit('set-show-title', val)"
          :currentSelectChatId="currentSelectChatId"
          @handle-no-list-chat="(val) => (isNoConversation = val)"
        />
      </div>
      <div v-if="!isList || isShowBoth" :class="['panel-box-chat']">
        <ChatBox
          v-if="currentSelectChatId != ''"
          :meProfile="meProfile"
          :otherProfile="otherProfile"
          :isFromList="isFromList"
          :isShowBoth="isShowBoth"
          @show-list-chat="
            () => {
              isList = true;
              currentSelectChatId = '';
            }
          "
          @set-show-title="(val) => $emit('set-show-title', val)"
          @reload-list="$refs.ChatList.getChatList()"
          @reload-detail-list="(val) => $refs.ChatList.setListNewCon(val)"
          @read-chat="(val) => $refs.ChatList.handleReadChat(val)"
          @handle-no-list-chat="(val) => (isNoConversation = val)"
        />
        <div
          v-if="currentSelectChatId == '' && isShowBoth"
          class="panel-wellcome-chat"
        >
          <div class="text-center">
            <b-img
              v-if="$store.state.logoPathUrl"
              :src="$store.state.logoPathUrl"
              alt="logo"
              height="50"
              class="mb-2"
            />
            <p class="mb-0">{{ $t("wellcomeToChat") }}</p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isNoConversation && currentSelectChatId == ''" class="h-100">
      <div class="panel-wellcome-chat">
        <div class="text-center">
          <b-img
            v-if="$store.state.logoPathUrl"
            :src="$store.state.logoPathUrl"
            alt="logo"
            height="50"
            class="mb-2"
          />
          <p class="mb-0">{{ $t("chatNotFound") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChatList from "@/components/chat/ChatList";
import ChatBox from "@/components/chat/ChatBox";
export default {
  name: "ChatPanel",
  components: {
    ChatList,
    ChatBox,
  },
  props: {
    isShowBoth: {
      required: false,
      type: Boolean,
    },
    isStateInbox: {
      required: false,
      type: Boolean,
    },
  },
  data() {
    return {
      isShowChat: false,
      isAlreadyPrepare: false,
      isFromList: false,
      meProfile: {
        seller: {},
      },
      otherProfile: {
        chatId: "",
      },
      isList: true,
      currentSelectChatId: "",
      isNoConversation: false,
    };
  },
  methods: {
    handlePrepareData: async function() {
      if (!this.isAlreadyPrepare) {
        this.isAlreadyPrepare = true;
        await this.getProfileInfo();
        this.otherProfile = this.$store.state.otherProfile;
        this.currentSelectChatId = this.otherProfile.chatId || "";
      }
    },
    getProfileInfo: async function() {
      let resData = await this.$callApi(
        "get",
        `${this.$baseUrl}/api/Profile/ShortProfile`,
        null,
        this.$headers,
        null
      );

      if (resData.result == 1) {
        this.meProfile.chatId = resData.detail.userDetail.chatId;
        this.meProfile.photoUrl = resData.detail.userDetail.seller.logo;
        this.meProfile.email = resData.detail.userDetail.email;
        this.meProfile.seller = resData.detail.userDetail.seller;
        this.updateMe();

        setInterval(() => {
          if (!this.$store.state.isSocketOpen)
            this.$store.dispatch("handleChatSocket", resData.detail.userDetail);
        }, 2000);
      }
    },
    updateMe() {
      let tempName = this.meProfile.chatId.split("getfin");
      tempName = "user" + tempName[1];
      let body = {
        name: `${this.meProfile.seller.name || tempName}`,
        email: [],
        photoUrl: `${this.meProfile.seller.logo}`,
        role: this.$chatRole,
      };

      fetch(`${this.$chatBaseUrl}/talkjs/user`, {
        method: "POST",
        headers: new Headers(this.$headersChat),
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((result) => {
          if (result.result) {
            this.isShowChat = true;
            this.$emit("set-loading", false);
          }
        })
        .catch((error) => console.log("error", error));
    },
    handleSelectChat(val) {
      if (this.currentSelectChatId != val) {
        this.otherProfile = {
          chatId: val,
        };
        this.isFromList = true;
        this.isList = false;
        this.currentSelectChatId = "";
        setTimeout(() => {
          this.currentSelectChatId = val;
        }, 50);
      }
    },
  },
  created() {
    this.handlePrepareData();
    this.isFromList = false;
  },
  beforeDestroy() {
    this.$store.commit("setOtherProfile", {
      id: 0,
      chatId: "",
    });
  },
};
</script>

<style lang="scss" scoped>
.panel-wellcome-chat {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60vh;
  width: 100%;
}

.panel-list-chat {
  width: 35%;
}
.panel-box-chat {
  width: 65%;
  height: 100%;
}
@media (max-width: 1440px) {
  .panel-list-chat {
    width: 40%;
  }
  .panel-box-chat {
    width: 60%;
  }
}
@media (max-width: 1024px) {
  .panel-list-chat {
    width: 50%;
  }
  .panel-box-chat {
    width: 50%;
  }
}
@media (max-width: 767.98px) {
  .panel-list-chat {
    width: 100%;
  }
  .panel-box-chat {
    width: 100%;
  }
}
</style>
